'use client'

import { useDashboard } from '@/providers/Dashboard'

import { DashboardToggle } from './DashboardToggle'

export function DashboardForm() {
  const {
    showXTimeline,
    setShowXTimeline,
    showMyBills,
    setShowMyBills,
    showWinTracker,
    setShowWinTracker,
    showSavedArticles,
    setShowSavedArticles,
  } = useDashboard()

  return (
    <div className="border-t border-border py-6">
      <div className="m-auto w-fit max-w-xl">
        <h2 className="font-family-body text-2xl font-semibold text-foreground">
          Dashboard Preferences
        </h2>
        <p className="mt-1 font-body text-sm text-muted-foreground">
          Customize the dashboard to your liking.
        </p>
        <form className="mt-6 space-y-4">
          <p className="mt-1 text-base font-medium text-foreground">
            When enabled, the sections below will be visible on your dashboard.
          </p>
          {/* X Timeline */}
          <DashboardToggle
            label="X (Twitter) Timeline"
            setValue={setShowXTimeline}
            value={showXTimeline}
          />
          {/* Bills Widget */}
          <DashboardToggle label="My Bills" setValue={setShowMyBills} value={showMyBills} />
          {/* Events Widget */}
          {/*<DashboardToggle label="My Events" setValue={setShowMyEvents} value={showMyEvents} />*/}
          {/* Saved Articles */}
          <DashboardToggle
            label="Saved Articles"
            setValue={setShowSavedArticles}
            value={showSavedArticles}
          />
          {/* Win Tracker */}
          <DashboardToggle
            label="Win Tracker"
            setValue={setShowWinTracker}
            value={showWinTracker}
          />
        </form>
      </div>
    </div>
  )
}
